import axios from 'axios'

const apiUrl = 'http://localhost:8080/campaignEvent'

export const GET_CAMPAIGN_EVENTS = 'GET_CAMPAIGN_EVENTS'
export const GET_CAMPAIGN_EVENT = 'GET_CAMPAIGN_EVENT'
export const SET_CAMPAIGN_EVENT = 'SET_CAMPAIGN_EVENT'

export const getCampaignEvents = (advertiserId) => {
  const config = {
    params: {
      created_advertiser_id: advertiserId
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, advertiserId ? config : null)
      .then(response => {
        dispatch({ type: GET_CAMPAIGN_EVENTS, campaignEvents: response.data })
      })
      .catch(error => {
        console.log(`error getting campaign events: ${error}`)
      })
  }
}

export const getCampaignEvent = (paramKey, paramVal) => {
  const config = {
    params: {
      [paramKey]: paramVal
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, config)
      .then(response => {
        dispatch({ type: GET_CAMPAIGN_EVENT, campaignEvent: response.data[0] })
      })
      .catch(error => {
        console.log(`error getting campaign event: ${error}`)
      })
  }
}

export const setCampaignEvent = (campaignEvent) => ({ type: SET_CAMPAIGN_EVENT, campaignEvent: campaignEvent })